export default `var _sf_async_config=_sf_async_config||{};_sf_async_config.uid=52075;_sf_async_config.domain="tamilmurasu.com.sg";_sf_async_config.flickerControl=!1;_sf_async_config.useCanonical=!0;var _sf_startpt=(new Date).getTime();`;
